// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BlogArticlesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  endCursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filter?: Types.InputMaybe<Types.ContentPageConnectionFilter>;
}>;


export type BlogArticlesQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, pages?: { __typename?: 'ContentPageConnection', totalCount?: number, edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, handle?: string, mainBlock?: string, publishDate?: string, sectionHandle?: string, smallImage?: string, title?: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string, hasNextPage: boolean } } } };

export type BlogArticlesFragment = { __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, handle?: string, mainBlock?: string, publishDate?: string, sectionHandle?: string, smallImage?: string, title?: string } };

export const BlogArticlesFragmentDoc = /*#__PURE__*/ gql`
    fragment BlogArticlesFragment on ContentPageEdge {
  node {
    id
    handle
    mainBlock
    publishDate
    sectionHandle
    smallImage
    title
  }
}
    `;
export const BlogArticlesQueryDocument = /*#__PURE__*/ gql`
    query BlogArticlesQuery($first: Int, $endCursor: String, $filter: ContentPageConnectionFilter) {
  content {
    id
    pages(
      first: $first
      after: $endCursor
      filter: $filter
      sort: {publishDate: -1}
    ) {
      edges {
        ...BlogArticlesFragment
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    ${BlogArticlesFragmentDoc}`;
export function useBlogArticlesQuery(baseOptions?: Apollo.QueryHookOptions<BlogArticlesQuery, BlogArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogArticlesQuery, BlogArticlesQueryVariables>(BlogArticlesQueryDocument, options);
      }
export function useBlogArticlesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogArticlesQuery, BlogArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogArticlesQuery, BlogArticlesQueryVariables>(BlogArticlesQueryDocument, options);
        }
export function useBlogArticlesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BlogArticlesQuery, BlogArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlogArticlesQuery, BlogArticlesQueryVariables>(BlogArticlesQueryDocument, options);
        }
export type BlogArticlesQueryHookResult = ReturnType<typeof useBlogArticlesQuery>;
export type BlogArticlesQueryLazyQueryHookResult = ReturnType<typeof useBlogArticlesQueryLazyQuery>;
export type BlogArticlesQuerySuspenseQueryHookResult = ReturnType<typeof useBlogArticlesQuerySuspenseQuery>;
export type BlogArticlesQueryQueryResult = Apollo.QueryResult<BlogArticlesQuery, BlogArticlesQueryVariables>;